import React,{useEffect, useState}  from 'react'
import moment from 'moment'

const CounterButton = ({onSubmit, disabled, startWithCountdown}) => {

    const [showSendSms, setShowSendSms] = useState(true);

    const [countDownTime, setCountDownTime] = useState("");    
   
    const[timerToClear,setTimerToClear] = useState(null);
   
    const timeForCountdown = 1*60*1000; // for 1 min

     const startTimer = (time) => {
        let showTime = time;
        const duration = moment.duration(showTime, 'milliseconds')
        setCountDownTime(duration.minutes() + ":" + duration.seconds())

        let t = setInterval(() => { 
            showTime = showTime - 1000;
            const intDuration = moment.duration(showTime, 'milliseconds')
            setCountDownTime(intDuration.minutes() + ":" + intDuration.seconds())
            // console.log( intDuration.seconds())
            if(showTime <= 0) {
                clearInterval(t);
                setShowSendSms(true);
                return;
            }
        }, 1000);

        return t;
     }
    
    const generateCodeHandler = () => {
        setShowSendSms(false);
        const myTymer = startTimer(timeForCountdown);
        setTimerToClear(myTymer);
        if(onSubmit) onSubmit();
    }


    useEffect(()=>{
        const startCountdown = () => {
            setShowSendSms(false);
            const myTymer = startTimer(timeForCountdown);
            setTimerToClear(myTymer);
        }

        if(startWithCountdown){
            startCountdown();
        }

    }, [startWithCountdown, timeForCountdown]);

    const countDownText = `Повторно генериране на код след ${countDownTime} мин.`

    // code for clearing time interavl from memory
    useEffect(() => {
        return () => {         
            clearInterval(timerToClear)
        }
    },[timerToClear]
    )

    return( <>
            { showSendSms  
            ? <button className="nuIns-btn nuIns-btn-heaven" type="button"  onClick={generateCodeHandler} disabled={disabled}>
                Генерирай код</button>
           
            : <button className="nuIns-btn nuIns-btn-outlined" type="button" disabled={true}>
                {countDownText}</button>
            }
        </>)
}

export default CounterButton;